import * as d3 from "d3-new";
export const generateMapChart = async (
  data,
  dataGeo,
  valuesToShow,
  color,
  config,
  zoom,
  pointSize
) => {
  const { width, height } = config;
  // The svg
  var svg = d3.create("svg").attr("width", width).attr("height", height);

  // Map and projection
  var projection = d3
    .geoMercator()
    .center([0, 0]) // GPS of location to zoom on
    .scale(100 + zoom) // This is like the zoom
    .translate([20 + width / 2, 30 + height / 2]);



  // Get the current center
  //
  // // Add a scale for bubble size
/*
  var valueExtent = d3.extent(data, function (d) {
    return d.value;
  });
*/

  //
  var size = d3
    .scaleSqrt([valuesToShow[0], valuesToShow[1]])
    //.domain([...valueExtent,...valuesToShow])  // What's in the data
    .range([1, pointSize]); // Size in pixel


  // Draw the map
  svg
    .append("g")
    .selectAll("path")
    .data(dataGeo)
    .enter()
    .append("path")
    .attr("fill", "#b8b8b8")
    .attr("d", d3.geoPath().projection(projection))
    .style("stroke", "none")
    .style("opacity", 0.3);

//
  // // Add circles:
  svg
    .selectAll("myCircles")
    .data(
      data.sort(function (a, b) {
        return +(b?.value ?? 0) - +(a?.value ?? 0);
      })
    )
    .enter()
    .append("circle")
    .attr("cx", function (d) {
      var pr = projection([+(d.longitude), +(d.latitude)]);
      return pr?.length && !isNaN(pr[0]) ? pr[0] : width/2;
    })
    .attr("cy", function (d) {
      var pr = projection([+(d.longitude), +(d.latitude)]);
      return pr?.length && !isNaN(pr[1])? pr[1] : height-20;
    })
    .attr("r", function (d) {
      return size(+(d?.value ?? 0));
    })
    .style("fill", function (d, i) {
      var pr = projection([+(d.longitude), +(d.latitude)]);
      if(pr?.length && (isNaN(pr[0])||isNaN(pr[1]))) return 'black';
      return color[i];
    })
    .attr("stroke", function (d) {
      return "none";
    })
    .attr("stroke-width", 1)
    .attr("fill-opacity", 0.4)
    .style("transform", "scale(0)")
    .transition()
    .delay(function (d, i) {
      return 30 * i;
    })
    .duration(300)
    .style("transform", "scale(1)");

  return svg.node();
};

function findCenter(markers) {
  let lat = 0;
  let lng = 0;
  for (let i = 0; i < markers.length; ++i) {
    lat += +markers[i].latitude;
    lng += +markers[i].longitude;
  }

  lat /= markers.length;
  lng /= markers.length;
  return { lat: +lat, lng: +lng };
}

function createGeoJSONFeatureCollection(points) {
  const features = points.map((point) => {
    return {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [+point.longitude, +point.latitude],
      },
      properties: {}, // Add properties as needed
    };
  });

  return {
    type: "FeatureCollection",
    features,
  };
}
function extendCoordinate(coordinate, factor) {
  if (coordinate < 0) {
    return Math.max(-170, coordinate * factor);
  } else {
    return Math.min(170, coordinate * factor);
  }
  return coordinate;
}
function extendCoordinateLat(coordinate, factor) {
  if (coordinate < 0) {
    return Math.max(-80, coordinate * factor);
  } else {
    return Math.min(80, coordinate * factor);
  }
  return coordinate;
}

function scaleTranslation(translation, scale) {
  var current = Math.abs(translation);
  var scaledTranslation = current * scale;
  var difference = scaledTranslation - current;
  if (translation < 0) {
    return translation - difference / 0.8;
  } else {
    return translation + difference / 1.5;
  }
}
